<template>
  <div>

    <!-- 标题 -->
    <div class="my-header">
        <mt-header fixed title="智慧停车优惠券" class="mt-header-content">
        </mt-header>
    </div>

    <div class="content">

         <div class="lists">
            <div class="list">
                <img src="../../assets/coupon.png" alt="">
                <div class="content-coupon">
                    <div v-if="couponMoney>=0">
                      <div class="moy">￥<span>{{couponMoney}}元</span></div>
                    </div>

                    <div v-else-if="couponMoney == -2 || couponMoney == '-2'">
                      <div class="moy"><span>时段免费</span></div>
                    </div>
                    <div v-else>
                      <div class="moy"><span>单次免费</span></div>
                    </div>
                    <em>满0元可用</em>
                    <i>{{this.parkName}}</i>
                    <!-- <i>有效期至：2020-10-18</i> -->
                </div>
            </div>
        </div>

        <div class="coupon-form">
            <mt-field label="车牌号码" placeholder="请输入车牌号码" type="plateNo" v-model="plateNo">
              <LicenseKeyboard ref="LicenseKeyboard" class="license-keyboard" fontSize="1.2rem" :isMobile="isMobile" v-model="plateNo"/>
            </mt-field>

            <mt-radio
                title="车牌颜色"
                v-model="plateTypeName"
                :options="['蓝牌', '黄牌', '新能源']">
            </mt-radio>
            <div class="btn-content" style="">
                <mt-button type="primary" class="btn-save" @click="applyCoupon" :disabled="btnDisable ? true : false">领取优惠券</mt-button>
            </div>
        </div>

    </div>

  </div>
</template>

<script>

import { MessageBox } from 'mint-ui'
export default {
  created () {
    this.getQueryParams()
    this.getCookies()
  },
  data () {
    return {
      isMobile: false,
      plateTypeName: '蓝牌',
      plateNo: '',
      couponId: '',
      couponMoney: '',
      parkName: '',
      merchantId: '',
      btnDisable: false
    }
  },
  methods: {
    // 获取页面参数
    getQueryParams () {
      this.couponId = this.$route.params.couponId
      this.couponMoney = this.$route.params.couponMoney
      this.parkName = this.$route.params.parkName
      this.merchantId = this.$route.params.merchantId
      this.parkCode = this.$route.params.parkCode
      // console.log('couponId=' + this.couponId + '，couponMoney=' + this.couponMoney)
    },
    // 优惠券领取方法
    applyCoupon () {
      // 判断参数是否正确
      if (this.merchantId === '' || this.couponId === '' || this.parkCode === '') {
        this.$toast('请重新扫描二维码领取优惠券')
        return false
      }
      if (this.plateNo === '') {
        this.$toast('请输入车牌号')
        return false
      }
      if (this.plateTypeName === '') {
        this.$toast('请选择车牌颜色')
        return false
      }
      MessageBox({
        title: '确认车牌信息',
        message: '车牌号码：' + this.plateNo + '，车牌颜色：' + this.plateTypeName,
        showCancelButton: true
      }).then(async action => {
        if (action === 'confirm') {
          this.applyCouponRequest()// 执行领取优惠券请求
        }
      }).catch(error => {
        if (error === 'cancel') {

        }
      })
    },

    // 领取优惠券请求
    async applyCouponRequest () {
      // 转换车牌类型
      const plateType = this.covertPlateType(this.plateTypeName)
      // 执行领取优惠券请求
      const { data: res } = await this.$http.get('couponApplylanneng', {
        headers: {},
        params: {
          merchantId: this.merchantId,
          token: this.couponId,
          plateNo: this.plateNo,
          plateType: plateType,
          parkCode: this.parkCode
        }
      })
      if (res.code === '0') {
        this.btnDisable = true
        // 设置cookie
        this.setCooikes()
        this.$toast('优惠券领取成功')
      } else {
        this.btnDisable = true
        MessageBox({
          title: '错误提示',
          message: res.message,
          showCancelButton: false
        })
      }
    },

    // 车牌颜色代码转换
    covertPlateType (plateTypeName) {
      if (plateTypeName === '蓝牌') {
        return '2'
      } else if (plateTypeName === '黄牌') {
        return '1'
      } else if (plateTypeName === '新能源') {
        return '5'
      } else {
        return '2'
      }
    },
    // 设置cookie
    setCooikes () {
      this.$cookies.set('rzzhtc_plateno', this.plateNo, -1)
      this.$cookies.set('rzzhtc_platetype', this.plateTypeName, -1)
    },
    // 获取cookie
    getCookies () {
      if (this.$cookies.isKey('rzzhtc_plateno')) {
        const rzzhtcPlateno = this.$cookies.get('rzzhtc_plateno')
        this.plateNo = rzzhtcPlateno
      }
      if (this.$cookies.isKey('rzzhtc_platetype')) {
        const rzzhtcPlatetype = this.$cookies.get('rzzhtc_platetype')
        this.plateTypeName = rzzhtcPlatetype
      }
    }
  },
  computed: {

  }
}
</script>

<style lang="less" scoped>

.my-header{
    .mt-header-content{
        background-color: #326DDE;
    }
}

.content {
    margin-top: 4.375rem;
}

.btn-content {
    padding: 30px 20px;
    width: 300px;
    margin: 0 auto;
    .btn-save {
        width: 100%;
        background-color: #326DDE;

    }
}

.lists{
  padding: 0 15px;
  .list{
    width: 100%;
    height: 120px;
    position: relative;
    margin-top: 15px;
    img{
      width: 100%;
      height: 120px;
    }
    .content-coupon{
      width: 60%;
      height: 120px;
      position: absolute;
      left: 30%;
      top: 0;
      padding: 10px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #ffffff;
      .moy{
        font-size: 15px;
        font-weight: bold;
        span{
          font-size: 25px;
        }
      }
      em{
        font-size: 12px;
        font-weight: bold;
        margin-top: 5px;
      }
      i{
        font-size: 12px;
        margin-top: 5px;
      }
    }
    .gray{
      color: #2B2B2B;
    }
  }
}

.coupon-form{
    margin-top: 30px;
    padding: 0 15px;
}

</style>
